// XXX: duplicates information in Helpers::AppVerifyRecaptcha !!!!!
export const ACTION_NAME__DONATION_PAGE__BA = "donation_page__ba"
export const ACTION_NAME__DONATION_PAGE__CC = "donation_page__cc"
export const ACTION_NAME__SPECIAL_DONATION_PAGE__CC =
  "special_donation_page__cc"
export const ACTION_NAME__SPECIAL_DONATION_PAGE__BA =
  "special_donation_page__ba"
export const ACTION_NAME__SOLICITATION_PAGE__CC = "solicitation_page__cc"
export const ACTION_NAME__SOLICITATION_PAGE__BA = "solicitation_page__ba"
export const ACTION_NAME__LOGIN = "login"
export const ACTION_NAME__REGISTER = "register" // TODO: change name to "signup"
export const ACTION_NAME__RESET_PASSWORD = "reset_password" // TODO: duplicated in app / views / devise / passwords / new.html.slim and app / views / devise / passwords / edit.html.slim
export const ACTION_NAME__RESEND_CONFIRMATION_INSTRUCTIONS =
  "resend_confirmation_instructions"
export const ACTION_NAME__MAGAZINE = "magazine"
export const ACTION_NAME__CONFERENCE__FREE_TICKETS = "conference__free_tickets"
export const ACTION_NAME__CONFERENCE__NONFREE_TICKETS =
  "conference__nonfree_tickets"
export const ACTION_NAME__CREATE_BANK_ACCOUNT_AND_SUSPEND_DONATION =
  "create_bank_account_and_suspend_donation"
export const ACTION_NAME__BOOK_PAPERBACK_CHECKOUT = "book_paperback_checkout"
export const ACTION_NAME__BOOK_HARDCOVER_CHECKOUT = "book_hardcover_checkout"
export const ACTION_NAME__BOOK_DIGITAL_CHECKOUT = "book_digital_checkout"
export const ACTION_NAME__BOOK_AUDIO_CHECKOUT = "book_audio_checkout"
export const ACTION_NAME__BOOK_CLUB = "book_club"
export const ACTION_NAME__NEWSLETTER_SUBSCRIPTION__REQUEST_SUBSCRIPTION =
  "newsletter_subscription__request_subscription"
export const ACTION_NAME__SPECIAL_DONATION__REQUEST_SUBSCRIPTION =
  "special_donation__request_subscription"
export const ACTION_NAME__PAYMENT_METHODS_ADD_BANK_ACCOUNT =
  "payment_methods_add_bank_account"
export const ACTION_NAME__PAYMENT_METHODS_ADD_CREDIT_CARD =
  "payment_methods_add_credit_card"
